import React, { useEffect } from "react";
import { useFetcher, useSearchParams } from "react-router-dom";
import { Button } from "../ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { BatchAction } from "./types";
import { ActionWrapper } from "@/utils/wretch";
import { toast } from "sonner";

interface ObjectBatchActionsProps extends React.HTMLAttributes<HTMLDivElement> {
    actions: BatchAction[];
    selectedItemIds: string[];
    selectAll: boolean;
    selectAllCount: number;
}

export function ObjectBatchActions({ actions, selectedItemIds, selectAll, selectAllCount, className, ...props }: ObjectBatchActionsProps) {
    const fetcher = useFetcher<ActionWrapper<{ toast?: string }>>();
    const [searchParams] = useSearchParams();

    const runAction = (action: BatchAction) => {
        if (!selectAll) {
            searchParams.set("id__in", selectedItemIds.join(","));
            searchParams.set("count", selectedItemIds.length.toString());
        } else {
            searchParams.set("selectAll", "");
            searchParams.set("count", selectAllCount.toString());
        }
        fetcher.submit({}, { method: "POST", action: `${action.base_url || "batch"}?action=${action.action}&${searchParams.toString()}`, encType: "application/json" });
    };

    useEffect(() => {
        if (fetcher.data) {
            if (fetcher.data.success) {
                toast.success(fetcher.data.content.toast || "Action effectuée avec succès");
            } else {
                toast.error(fetcher.data.message || "Une erreur est survenue");
            }
        }
    }, [fetcher.data]);

    return (
        <div {...props}>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant="outline" size="sm" disabled={fetcher.state != "idle"}>
                        {fetcher.state == "idle" ? "Actions..." : "Traitement en cours..."}
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    {actions.map((action, i) => (
                        <DropdownMenuItem key={`${action.action}_${i}`} onSelect={() => runAction(action)}>
                            {action.label}
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
